import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import LocalStorageUtil from '../user/LocalStorageUtil';

const Login = () => {
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  const baseLocalDevUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:3000';
  const [username, setUsername] = useState('');
  const [userpassword, setPassword] = useState('');
  const navigate = useNavigate();
  const handleLogin = async () => {
    try {
      const response =  await axios.post(`${baseHostUrl}/login`, {
        username: username,
        userpassword: userpassword
      }, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      });
      LocalStorageUtil.saveSession({ username,usrprofile:response.data.usrprofile || {} });
      //LocalStorageUtil is synchronous
      navigate('/dashboard');
      //window.location.replace('/lemma'); // ✅ redirect without keeping login page in history 
      // alert(`usrprofile:\n${JSON.stringify(response.data.usrprofile, null, 2)}`);
      // console.log('matched:', response.data.usrprofile);
    } catch (error) {
      alert('Login failed!');
    }
  };

  return (
    <div className="login_wrapper">
      <div className="login_container">
        <h2 className="login_title">Login</h2>

        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Username"
          className="login_input"
        />

        <input
          type="password"
          value={userpassword}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          className="login_input"
        />

        <button
          onClick={handleLogin}
          className="login_button"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;